import React, { useContext } from "react";
import { FileContext } from "./Dashboard";
import { Link } from "react-router-dom";

export default function Import() {
  const { setIsSelected, setSelectedFile } = useContext(FileContext);

  return (
    <>
      <section className="import-container">
        <h1 className="section-header import-header">Import your trades</h1>
        <label className="btn import-btn" htmlFor="uploadCSV">
          Browse
        </label>
        <input
          accept=".csv"
          type="file"
          id="uploadCSV"
          name="trading-file-upload"
          onClick={(e) => {
            e.target.value = "";
          }}
          onChange={(e) => {
            if (e.target.files) {
              setSelectedFile(e.target.files[0]);
              setIsSelected(true);
            } else {
              setIsSelected(false);
            }
          }}
        />

        <div className="btn-subtext">.csv file format required &nbsp;</div>
        <div className="btn-subtext"> (max. file size 5MB) </div>
      </section>
      <section id="demo-cta-section">
        <Link className="link-text cta" to="/dashboard-demo">
          Show me a demo first
        </Link>
      </section>
    </>
  );
}
